import React from 'react';
import { DynamicField, DynamicFieldTypes } from 'src/components/dynamic-widget';
import DynamicFormWidget from 'src/components/dynamic-widget/DynamicFormWidget';
import { DataService } from 'src/services/data-service';
import GenericDialog from 'src/components/GenericDialog';
import { useAppDispatch } from 'src/redux/hooks';
import { showAlert } from 'src/redux/alert/alertReducer';
import { IFaq, IUpdateFaqModel } from '.';

interface IAddFaqProps {
  onSuccess: () => void;
  onClose: () => void;
  faq?: IFaq | null;
}

const languages = {
  en: 'English',
  ar: 'Arabic',
  fr: 'French',
};

const AddFaq: React.FC<IAddFaqProps> = ({ onSuccess, onClose, faq }) => {
  const dispatch = useAppDispatch();
  const isEditMode = !!faq;

  const formConfig = React.useMemo((): Record<string, DynamicFieldTypes> => ({
    title: {
      type: DynamicField.TEXT,
      required: true,
      name: 'title',
      title: 'Title',
      value: faq?.title || '',
      disabled: false
    },
    body: {
      type: DynamicField.TEXTAREA,
      required: true,
      name: 'body',
      title: 'Body',
      value: faq?.body || '',
      disabled: false
    },
    language: {
      type: DynamicField.SELECT,
      required: true,
      name: 'language',
      title: 'Language',
      value: faq?.language || '',
      disabled: false,
      items: languages
    }
  }), [faq]);

  const submit = React.useCallback(async (data: Record<string, any>) => {
    const endpoint = isEditMode ? 'api/Faq/update' : 'api/Faq/create';
    const payload = isEditMode
      ? { id: faq.id, ...data } as IUpdateFaqModel
      : data;

    const response = await DataService.post(
      endpoint,
      payload,
      undefined
    );

    if (response.ok) {
      onSuccess();
      return true;
    } else {
      const result: { message: string } = await response.json();
      dispatch(showAlert({
        message: result.message || 'An error occurred!',
        type: 'error'
      }));
      return false;
    }
  }, [dispatch, onSuccess, isEditMode, faq]);

  return (
    <GenericDialog
      open={true}
      title={isEditMode ? 'Edit FAQ' : 'Add FAQ'}
      onClose={onClose}
    >
      <DynamicFormWidget
        title=""
        fields={formConfig}
        onSubmit={submit}
      />
    </GenericDialog>
  );
};

export default AddFaq;
